module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex w-100 align-items-center"
  }, [_c('div', {
    staticClass: "col-md-3 px-0"
  }, [_c('checkbox', {
    attrs: {
      "name": "allotment",
      "value": "1"
    },
    model: {
      value: (_vm.deliverNotification),
      callback: function($$v) {
        _vm.deliverNotification = $$v
      },
      expression: "deliverNotification"
    }
  }, [_vm._v("Deliver notification")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-right"
  }, [_c('span', {
    staticClass: "font-weight-600 pointer color-6",
    attrs: {
      "disabled": _vm.getIsUpdatingEvent
    },
    on: {
      "click": _vm.deleteEvent
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary px-5",
    attrs: {
      "disabled": _vm.getIsUpdatingEvent
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn success px-5",
    attrs: {
      "disabled": _vm.validations.$invalid || _vm.getIsUpdatingEvent || _vm.isCreatingEvent
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges(false)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.getIsCreatSingleEvent) ? _c('button', {
    staticClass: "btn success px-5",
    attrs: {
      "disabled": _vm.validations.$invalid || _vm.getIsUpdatingEvent || _vm.isCreatingEvent
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges(true)
      }
    }
  }, [_vm._v("Save & Book")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7ea32036", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea32036"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/footerButtons.vue
// module id = 963
// module chunks = 0